import { UserType } from "@mcleod/core";
import { DataSource } from "@mcleod/components";
import { AutogenLayoutUserTableFactoringCompany } from "./autogen/AutogenLayoutUserTableFactoringCompany";
import { UserTableController  } from "./UserTableController";
import { UserTableLayout } from "./UserTableLayout";

export class UserTableFactoringCompany extends AutogenLayoutUserTableFactoringCompany implements UserTableLayout {
    public getSourceUsers(): DataSource {
        return this.sourceUserSettings;
    }

    public getUserType(): UserType {
        return UserType.FACTORING_COMPANY;
    }

    override onLoad(): void | Promise<void> {
        new UserTableController(this);
    }
}
